import $foreign from "./foreign.cjs";
var _match = $foreign._match;
var _replaceBy = $foreign._replaceBy;
var _search = $foreign._search;
var flagsImpl = $foreign.flagsImpl;
var regexImpl = $foreign.regexImpl;
var replace = $foreign.replace;
var showRegexImpl = $foreign.showRegexImpl;
var source = $foreign.source;
var split = $foreign.split;
var test = $foreign.test;
export { _match, _replaceBy, _search, flagsImpl, regexImpl, replace, showRegexImpl, source, split, test };
